import React from 'react'
import PropTypes from 'prop-types'

Container.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node
}

export default function Container({ id, children }) {
  return (
    <div
      id={id}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 10 }}
    >
      {children}
    </div>
  )
}
